import { colors } from '@mui/material';
import PropTypes from 'prop-types';

RequiredLabel.propTypes = {
  required: PropTypes.bool,
  label: PropTypes.string,
};

export default function RequiredLabel({ label = '', required = false }) {
  return (
    <div>
      {label}
      {required && (
        <span
          style={{
            color: colors.red[500],
          }}
        >
          &nbsp; *
        </span>
      )}
    </div>
  );
}

export const RequiredWithoutLabel = ({ required = false }) => {
  return (
    <>
      {required && (
        <span
          style={{
            color: colors.red[500],
          }}
        >
          &nbsp; *
        </span>
      )}
    </>
  );
};

RequiredWithoutLabel.propTypes = {
  required: PropTypes.bool,
};
